import React from 'react';
import { numberWithSpaces } from '../../../../utils/utils';
import styles from './Table.module.scss';

export default function Table({
  data,
  keys,
  unit,
  indexBy,
}) {
  const getUnit = (value) => {
    if (unit === 'k€' || unit === 'K') {
      return value / 1000;
    }
    return value;
  };
  return (
    <div className={styles.table} >
      <table>
        <thead>
          <tr>
            <th scope="col">Type</th>
            {keys.map((k) => <th key={k} scope="col">{k}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((d) => (
              <tr key={d[indexBy]}>
              <th scope="row">{d[indexBy]} {d?.unit && <span>({d?.unit})</span>}</th>
              {keys.map((k) => <td key={k} scope="col">{numberWithSpaces(getUnit(d[k]).toFixed(2))} {unit}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
